// @flow

import {useContext} from 'react';

import {ConsentContext} from 'modules/Common/Context/Consent';

export const useConsent = () => {
  const consentContext = useContext(ConsentContext);
  if (consentContext === null) {
    throw new Error('useConsent() must be used within a <ConsentProvider>');
  }
  return consentContext;
};
